import { post, get, _delete } from '../../../assets/api';

function saveJob(data){
    const payload = {
        ...data
    };

    if (data._id) {
        return new Promise((resolve, reject) => {
            post(`/api/v1/job/update/${data._id}`, payload, { auth: true })
                .then(async res => {
                    if (res.status === 200 || res.status === 201) {
                        resolve({
                            status: 200,
                            _id: data._id,
                        });
                    } else {
                        throw new Error('status not handled')
                    }
                }).catch(error => {
                    console.error(error);
                    resolve({
                        status: 500,
                        msg: 'Please try again!'
                    });
                });
        })
    }

    return new Promise((resolve, reject) => {
        post('/api/v1/job/add', payload, { auth: true })
            .then(async (res) => {
                if(res.status === 201) {
                    const data = await res.json();
                    resolve({
                        status: 200,
                        _id: data._id
                    })
                } else if (res.status === 409) {
                    const data = await res.json();
                    resolve({
                        status: 409,
                        msg: data.msg
                    });
                } else if (res.status === 500) {
                    const data = await res.json();
                    if (data.error) {
                        resolve({
                            status: 500,
                            msg: data.error
                        });
                    } else {
                        throw new Error('status not handled');
                    }
                } else {
                    throw new Error(`status not handled ${res.status}`);
                }
            }).catch(error => {
                console.error(error);
                resolve({
                    status: 500,
                    msg: 'Please try again!'
                });
            });
    })

}

function listJobs() {
    return new Promise((resolve, reject) => {
        get('/api/v1/job/all?scope=cms', undefined, { auth: true })
         .then(async (res) => {
            if (res.status === 200) {
                const data = await res.json();
                resolve({
                    data: data || [],
                    status: 200
                });
            } else {
                throw new Error('status not handled');
            }
         }).catch(error => {
             console.error('error');
             reject(error);
         })
    })
}

function deleteJobs(payload){
    return new Promise((resolve, reject) => {
        _delete(`/api/v1/job/delete`, payload, { auth: true })
            .then(res => {
                if (res.status === 200) {
                    resolve({
                        status: 200
                    });
                } else {
                    throw new Error('status not handled');
                }
            }).catch(error => {
                console.error(error);
                reject(error);
            })
    })
}

function getJob(id){
    return new Promise((resolve, reject) => {
        get(`/api/v1/job/${id}`, undefined, { auth: true })
            .then(async (res) => {
                if (res.status === 200) {
                    const data = await res.json();
                    resolve({
                        status: 200,
                        data: data || {}
                    });
                } else {
                    throw new Error('status not handled');
                }
            }).catch(error => {
                console.error(error);
                reject(error);
            })
    })
}

export {
    listJobs,
    saveJob,
    getJob,
    deleteJobs
}
